<!-- 教育局-学生托管统计 -->
<template>
  <div>
    <div class="index" v-show="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
      </div>
      <div v-if="org_type!='a'" class="Homeboxtop_nav_tab">
        <span
          v-for="(item, index) in tabList"
          :class="['res-tab', { active: item.area_name === tabName }]"
          :key="index + item.area_name"
          @click="tabClick(item)"
        >
          {{ item.area_name }}
        </span>
      </div>

      <header class="m-t">
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>投诉反馈量TOP5</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
				<!-- <span class="circle"></span>
				<span>近七天学生出勤变化</span> -->
			</div>
          <div id="echarts-box2"></div>
        </div>
      </header>
      <div class="header-item-title">
        <span class="circle"></span>
        <span>投诉处理进展</span>
      </div>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane v-if="this.org_type!='a'" label="按区域" name="region"></el-tab-pane>
    <el-tab-pane v-else label="按学校" name="region"></el-tab-pane>
    <el-tab-pane label="按机构" name="mechanism"></el-tab-pane>
  </el-tabs>
      <div class="m-t">
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
            <el-select
              v-model="queryParams.semester"
              clearable
              placeholder="选择学年学期"
              class="label"
            >
              <el-option
                v-for="item in semesterList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryParams.time"
              type="daterange"
              style="width: 240px"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
		 <el-form-item label="">
		  <el-select
              v-model="queryParams.risk"
              clearable
              placeholder="风险等级"
              class="label"
            >
              <el-option
                v-for="item in riskList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
		 </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column  prop="a" v-if="activeName=='region' &&  org_type!='a' " label="区域" align="center">
            </el-table-column>
            <el-table-column prop="a" v-else label="学校" align="center">
            </el-table-column>
			<el-table-column prop="a" v-if="activeName=='mechanism'" label="机构" align="center">
            </el-table-column>
            <el-table-column prop="b" label="投诉总数" align="center">
            </el-table-column>
            <el-table-column prop="c" label="已处理数" align="center">
            </el-table-column>
            <el-table-column prop="d" label="待处理数" align="center">
            </el-table-column>
            <el-table-column prop="e" label="本周新增数" align="center">
            </el-table-column>
			<el-table-column prop="f" label="风险等级" align="center">
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import * as echarts from "echarts";
export default {
  components: {},
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage:15,
      queryParams: {
        semester: "",
        campus: "",
        grade: "",
        class: "",
        time: "",
		risk:"",
      },
	  activeName: 'region',
      semesterList: [
        { id: "xq1", label: "2021~2022年度下学期" },
        { id: "xq2", label: "2021~2022年度上学期" },
        { id: "xq3", label: "2020~2021年度下学期" },
        { id: "xq4", label: "2020~2021年度上学期" },
        { id: "xq5", label: "2019~2020年度下学期" },
        { id: "xq6", label: "2019~2020年度上学期" },
      ],
	  riskList: [
        { id: "xq1", label: "高" },
        { id: "xq2", label: "中" },
        { id: "xq3", label: "低" },
      ],
      tableData: [ ],   
      detail: {
        info: {},
        show: false,
      },
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      weekDate: [],
      pickerOptions: {
        disabledDate(time) {
          // return time.getTime() > Date.now();
        },
      },
      tabList: [
        { area_name: "全市" },
        { area_name: "汉阳区" },
        { area_name: "东西湖区" },
        { area_name: "硚口区" },
        { area_name: "江夏区" },
        { area_name: "经济技术开发区" },
        { area_name: "东湖高新区" },
        { area_name: "蔡甸区" },
        { area_name: "江汉区" },
        { area_name: "江岸区" },
        { area_name: "新洲区" },
        { area_name: "武昌区" },
        { area_name: "洪山区" },
        { area_name: "黄陂区" },
        { area_name: "青山区" },
        { area_name: "东湖风景" },
      ],
      tabName: "全市",
      xAxisData:[],
      seriesData:[]
    };
  },
  watch: {},
  	computed:{
		// 教育局级别判断	省级:99  市级:1,10  区县级:2,20,4,40
	 org_type(){
			let str = '';
			if(sessionStorage.getItem("user_level") === "99"){
				str = 'p'
			}
			if(["1", "10"].indexOf(sessionStorage.getItem("user_level")) > -1){
				str = 'c'
			}
      if(["2", "20","4", "40"].indexOf(sessionStorage.getItem("user_level")) > -1){
				str = 'a'
			}
			return str;
		},
	},
  created() {
    this.initData()
    this.getDataList();
	this.handleClick();
	 },
  methods: {
    initData(){
       if(this.org_type=='a'){
           this.xAxisData=["新河\n街小学", "白鹭街\n小学", "武汉市\n余家头\n小学", "武泰闸\n小学", "丁字桥\n小学"]
           this.seriesData= [55, 42, 40, 32, 30]

       }else{
         this.xAxisData= ["江夏区", "江岸区", "武昌区", "洪山区", "江汉区"],
         this.seriesData= [8, 6, 5, 4, 3]
       }
    },
    tabClick(item) {
      this.tabName = item.area_name;
    },
	  handleClick(tab, event) {
        // console.log('000000',tab,this.activeName );
	     if(this.activeName=='mechanism'){
            this.tableData= [
				{ a: "智课	",     b: "33", c: "21", d: "9", e:  "3" ,f:'低'},
				{ a: "欧美思	", b: "40", c: "19", d: "14", e: "7" ,f:'中'},
				{ a: "第七感官",   b: "39", c: "28", d: "11", e: "0" ,f:'中'},
				{ a: "黑色空间",   b: "45", c: "26", d: "10", e: "9" ,f:'中'},
				{ a: "小鱼	",     b: "30", c: "13", d: "17", e: "0" ,f:'中'},
				{ a: "许先望	", b: "54", c: "25", d: "20", e: "9" ,f:'高'},
				{ a: "果力教育",   b: "35", c: "22", d: "10", e: "3" ,f:'中'},
				{ a: "智位科技",   b: "41", c: "26", d: "8", e:  "7" ,f:'低'},
				{ a: "海鸟信息",   b: "35", c: "24", d: "11", e: "0" ,f:'中'},
				{ a: "博客音乐",   b: "40", c: "19", d: "16", e: "5" ,f:'低'},
			]
		 }else{
       if(this.org_type=='a'){
          this.tableData= [
              { a: "新河街小学	    ",  b: "50", c: "14",  d: "16", e: "84.41%"  ,f:'低' },
              { a: "白鹭街小学     	 ", b: "55", c: "12",  d: "18", e: "94.41%" ,f:'高'  },
              { a: "武汉市余家头小学",  b: "40", c: " 2",  d: " 18", e: "75.41%"   ,f:'中'  },
              { a: "武泰闸小学	    ",  b: "42", c: " 12", d: "18", e: "95.41%"   ,f:'高'  },
              { a: "丁字桥小学	     ", b: "20", c: " 4	", d: "26", e: "94.41%",f:'中'},
              { a: "解放桥小学	    ",  b: "20", c: " 3	", d: "17", e: "89.41%"    ,f:'高'},
              { a: "武昌实验小学    ",  b: "30", c: " 13", d: "17", e: "88.41%"  ,f:'中' },
              { a: "棋盘街小学	    ",  b: "32", c: " 7	", d: "23", e: "92.41%"  ,f:'低' },
              { a: "徐东路小学	    ",  b: "30", c: " 6	", d: "24", e: "95.41%"  ,f:'中' },
              { a: "复兴路小学	    ",  b: "28", c: " 5	", d: "25", e: "96.41%"  ,f:'低' },
            ]
       }else{
         this.tableData= [
				{ a: "汉阳区", b: "5180", c: "3", d: "45", e: "84.41%"  ,f:'低' },
				{ a: "东西湖区", b: "4180", c: "2", d: "45", e: "94.41%" ,f:'高'  },
				{ a: "硚口区", b: "3180", c: "3", d: "45", e: "75.41%"   ,f:'中'  },
				{ a: "江夏区", b: "5280", c: "2", d: "38", e: "95.41%"   ,f:'高'  },
				{ a: "经济技术开发区", b: "4180", c: "2", d: "38", e: "94.41%",f:'中'},

				{ a: "东湖高新区", b: "5100", c: "1", d: "38", e: "89.41%"    ,f:'高'},
				{ a: "蔡甸区", b: "3180", c: "3", d: "45", e: "88.41%"  ,f:'中' },
				{ a: "江汉区", b: "3180", c: "3", d: "45", e: "92.41%"  ,f:'低' },
				{ a: "江岸区", b: "2180", c: "3", d: "45", e: "95.41%"  ,f:'中' },
				{ a: "新洲区", b: "3580", c: "3", d: "38", e: "96.41%"  ,f:'低' },

				{ a: "武昌区", b: "3780", c: "4", d: "38", e: "86.41%"   ,f:'中'   },
				{ a: "洪山区", b: "5280", c: "5", d: "45", e: "88.41%"   ,f:'低'   },
				{ a: "黄陂区", b: "4180", c: "3", d: "45", e: "87.41%"    ,f:'低'  },
				{ a: "青山区", b: "3880", c: "3", d: "45", e: "99.41%"     ,f:'中' },
				{ a: "东湖风景", b: "3180", c: "3", d: "38", e: "90.41%"   ,f:'低' },
			]
       }
			   
		 }
      },
    async getDataList() {
      let params = {
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        schoolYearSemester: this.queryParams.semester,
        campusId: this.queryParams.campus,
        classId: this.queryParams.class,
        gradeId: this.queryParams.grade,
        page: this.pageNum,
        limit: this.pageSize,
      };
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    init() {
      let vm = this;
      this.$nextTick(() => {
        // 圆环图
        let chartDom1 = document.getElementById("echarts-box1");
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: "category",
            data:this.xAxisData,
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: "solid",
                color: "#DDDDDD", //轴线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#999999", //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data:this.seriesData,
              type: "bar",
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: "none", //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: "#5BB0FF" },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999",
                    },
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart1.setOption(option1);

        // 折线图
        let chartDom2 = document.getElementById("echarts-box2");
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: "category",
            data: ["许先望", "果力教育", "智位科技", "海鸟信息", "博客音乐"],
            axisLine: {
              //坐标线
              lineStyle: {
                type: "solid",
                color: "#DDDDDD", //轴线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#999999", //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: [10, 8, 6, 5, 4],
              type: "bar",
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: "none", //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: "#51D6A6" },
                  ]),
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999",
                    },
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);
      });
    },
  },
  mounted() {
    // this.semesterList=this.semesterArr.map(v=>({label:v.schoolYear+'第'+v.semester+'学期',id:v.schoolYear+'_'+v.semester}))
    let arr = [];
    for (let i = 1; i <= 7; i++) {
      const time = new Date(new Date().setDate(new Date().getDate() + i - 7));
      const year = time.getFullYear();
      const month = `0${time.getMonth() + 1}`.slice(-2);
      const strDate = `0${time.getDate()}`.slice(-2);
      arr.push(`${month}-${strDate}`);
    }
    this.weekDate = arr;
    this.init();
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }

  header {
    width: 100%;
    height: 350px;
    display: flex;
    .header-item {
      width: 50%;

      .header-item-text {
        font-size: 14px;
        color: #666;
        padding-left: 20px;
        margin-top: 5px;
      }
    }
    #echarts-box1 {
      width: 80%;
      height: 280px;
    }
    #echarts-box2 {
	  margin-top: 30px;
      width: 90%;
      height: 280px;
    }
  }
  .header-item-title {
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
    .circle {
      width: 8px;
      height: 8px;
      display: inline-block;
      background: #4991e1;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
  .Homeboxtop_nav_tab {
    span {
      padding-bottom: 10px;
    }
  }
}
 ::v-deep .el-tabs__nav {
    height: 50px;
    margin-top: 12px;
}
</style>
